module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_31.7ee7a1ef.png";